import { useTranslation } from 'next-i18next';
import { ComponentProps, useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { Box, ButtonV2, TextArea } from '@bridebook/ui';
import { Rsvp } from '@bridebook/models/source/models/Weddings/Guests.types';
import {
  useRsvpForms,
  useRsvpData,
  useRsvpNavigation,
  useRsvpState,
} from '../../guest-rsvp.context';
import GuestRsvpHeader from '../../partials/header';
import componentStyles from '../substep.style';
import { getThemeProperties } from '@bridebook/web/lib/wedding-website/utils/get-theme-properties';
import SubmitButtonDesktopWrapper from '../../partials/submit-button-desktop-wrapper';
import SubmitButtonMobileWrapper from '../../partials/submit-button-mobile-wrapper';

interface IContinueButtonProps {
  onClick: ComponentProps<typeof ButtonV2>['onClick'];
  styleWrapper: ComponentProps<typeof ButtonV2>['styleWrapper'];
  children: string;
}

const ContinueButton: React.FC<IContinueButtonProps> = ({ onClick, styleWrapper, children }) => (
  <ButtonV2 styleWrapper={styleWrapper} onClick={onClick}>
    {children}
  </ButtonV2>
);

const NoteStep: React.FC = () => {
  const { t } = useTranslation('weddingWebsite');
  const { setStep } = useRsvpNavigation();
  const { questionsForm, eventsForm, nameForm } = useRsvpForms();
  const { theme } = useRsvpData();
  const { isPreview } = useRsvpState();

  const themeProperties = useMemo(() => getThemeProperties(theme), [theme]);
  const styles = useMemo(
    () => componentStyles(themeProperties, isPreview),
    [themeProperties, isPreview],
  );

  const handleContinue: ComponentProps<typeof ButtonV2>['onClick'] = () => {
    setStep('RSVP_FORM.SUMMARY');
  };

  const guestName = nameForm.getValues('fullName') || '';
  const isComing = Object.values(eventsForm.getValues()).some(
    (eventResponse) => eventResponse === Rsvp.YES,
  );

  return (
    <>
      <Box style={styles.substepWrapper}>
        <GuestRsvpHeader />
        <Box style={styles.note.nameWrapper}>
          <Box style={styles.note.name}>{guestName}</Box>
          <Box>
            {isComing
              ? t('rsvp.guest.note.subtitle.isComing')
              : t('rsvp.guest.note.subtitle.notComing')}
          </Box>
        </Box>
        <Box style={styles.note.noteWrapper}>
          <Box style={styles.note.label}>{t('rsvp.guest.note.fieldTitle')}</Box>
          <Controller
            control={questionsForm.control}
            name="note"
            render={({ field }) => (
              <TextArea
                label={t('rsvp.guest.note.label')}
                placeholder={t('rsvp.guest.note.placeholder')}
                name={field.name}
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}></TextArea>
            )}
          />
        </Box>
        <SubmitButtonDesktopWrapper>
          {' '}
          <ContinueButton onClick={handleContinue} styleWrapper={styles.continueButton}>
            {t('rsvp.guest.common.continue')}
          </ContinueButton>
        </SubmitButtonDesktopWrapper>
      </Box>
      <SubmitButtonMobileWrapper>
        {' '}
        <ContinueButton onClick={handleContinue} styleWrapper={styles.continueButton}>
          {t('rsvp.guest.common.continue')}
        </ContinueButton>
      </SubmitButtonMobileWrapper>
    </>
  );
};

export default NoteStep;
